export default __webpack_public_path__ + "static/media/full-team-picture-kickoff-2019.4e590e9d.jpg";